import { createFileRoute } from "@tanstack/react-router";
import { StudyGroupLayout } from "@/components/navigation/StudyGroupLayout";
import { NotFoundPage } from "@/features/error-pages/components/NotFoundPage";

export const Route = createFileRoute("/study-group/$study-group-id")({
  component: StudyGroupLayout,
  notFoundComponent: NotFoundPage,
  loader: ({ params }) => {
    return { studyGroupId: params["study-group-id"] };
  },
  validateSearch: (search) => {
    return search as Record<string, unknown>;
  },
});
